import { createActions } from 'redux-actions';

import types from 'state/direct-order-recurring/quote/actionTypes';

const { directOrderRecurring } = createActions({
  [types.SET_QUOTE]: (quote) => ({ quote }),
  [types.CLEAN_QUOTE]: () => ({}),
  [types.SET_QUOTE_ERROR]: ({ errorType = '' }) => ({ errorType }),
  [types.CLEAN_QUOTE_ERROR]: () => ({}),
});

export default directOrderRecurring;
